import { Alert } from '@mui/material';
import { AdminRouteLayout } from './AdminRoutePageShared';

export default function RiskPolicySimulatorPage() {
  return (
    <AdminRouteLayout title="Simulator" breadcrumbTitle="Risk & Policy">
      <Alert severity="info">
        The `POST /v2/admin/risk/simulate` route is active, but its request payload contract is not yet documented in the contract file, so the simulator action remains intentionally unwired.
      </Alert>
    </AdminRouteLayout>
  );
}
